import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';

export const selectProposalItemSchema = createSelectSchema(
  schema.proposalItems,
);

export const insertProposalItemSchema = createInsertSchema(
  schema.proposalItems,
  {
    lineNumber: z.number().min(1),
    quantity: z.string().min(1),
    proposalId: z.string().uuid(),
  },
);

export const updateProposalItemSchema = insertProposalItemSchema
  .partial()
  .extend({
    id: z.string(),
  });

const ProposalItemsQuerySchema = z.object({
  lineNumber: z.string().optional(),
});

export const getProposalItemsQuerySchema = ProposalItemsQuerySchema.merge(
  z.object({
    limit: z.coerce.number().optional().default(25),
    offset: z.coerce.number().optional().default(0),
    page: z.coerce.number().optional(),
    proposalId: z.string().uuid(),
    costEstimate: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [];
        }
        return val.split(',').map((num) => Number(num));
      })
      .default([]),
    quantity: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [];
        }
        return val.split(',').map((num) => Number(num));
      })
      .default([]),
    sort: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [
            {
              id: 'lineNumber',
              desc: false,
            },
          ];
        }

        try {
          const parsed = JSON.parse(val);
          const sortSchema = z.array(
            z.object({
              id: z.string(),
              desc: z.boolean(),
            }),
          );

          const result = sortSchema.safeParse(parsed);

          if (!result.success) {
            return [
              {
                id: 'lineNumber',
                desc: false,
              },
            ];
          }

          return result.data;
        } catch {
          return [
            {
              id: 'lineNumber',
              desc: false,
            },
          ];
        }
      })
      .default([]),
  }),
);

export const getProposalItemsWithBidItemsQuerySchema = z.object({
  proposalId: z.uuid(),
  limit: z.coerce.number().optional().default(50),
  offset: z.coerce.number().optional().default(0),
});

export const getProposalTotalsQuerySchema = z.object({
  proposalId: z.uuid(),
});

export const getProposalGroupTotalsQuerySchema = z.object({
  proposalId: z.uuid(),
  groupBy: z.enum(['category', 'collection']),
});

export const getProposalItemsCountQuerySchema = ProposalItemsQuerySchema;
